import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import collapse from '@alpinejs/collapse';
import intersect from '@alpinejs/intersect';
import Components from 'components';
import Plugins from 'plugins';
import mapbox from 'components/mapbox';
import ScrollAnimate from 'components/scrollanimate';

// Initialise Alpine
window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.plugin(intersect);
Alpine.start();


// block specific scripts (see /blocks/block.example.js)
// e.g. import "blocks/hero/hero001"

document.querySelectorAll('.--card-module').forEach(item => new ScrollAnimate(item));

jQuery(function($) {
    Components.init();
    Plugins.init();
    Alpine.plugin(focus);

    // Auto-populate event form fields
    const eventNameField = document.querySelector('.eventname input');
    const eventUrlField = document.querySelector('.eventurl input');
    
    if (eventNameField) {
        // Get the page title (event name)
        const pageTitle = document.title.split(' - ')[0]; // Assuming the site name is after the dash
        eventNameField.value = pageTitle;
    }
    
    if (eventUrlField) {
        // Get the current page URL
        eventUrlField.value = window.location.href;
    }
    //const MAPBOXAPI = process.env.MAPBOXAPI ?? '';
    const MAPBOXAPI = 'pk.eyJ1Ijoib3h0c21hcmtldGluZyIsImEiOiJjbTdvbjVvMXowNXJqMmpzZWJpeDJ2cXN4In0.ToxLIWSjcJfMMpfpSaDJVQ';

    let maps = [
        'map1', 'map2'
    ]

    maps.forEach(map => {
        /* Start Mapbox */
        if(!document.getElementById(map)) {
            return;
        }
        
        let mapInstance = new mapbox();
        let mapEntries = document.getElementById(map).parentNode.querySelector('.map-entries');

        if (mapEntries) {
            mapInstance.init({
                id: map,
                accessToken: MAPBOXAPI,
                style: 'mapbox://styles/mapbox/streets-v10',
                center: [
                    mapEntries.dataset.startlng, 
                    mapEntries.dataset.startlat
                    ],
                zoom: parseFloat(mapEntries.dataset.zoom),
                mapEntries
            });
        }
    });
});


// Modify Navigation if Hero Product is Detected
// if(document.querySelector('.heroproduct')) {
//     if(window.innerWidth > 630) {
//         let header = document.querySelector('header#header');
//         let headerGap = document.querySelector('.header-gap');
//         let innerHeader = header.querySelector('.container > div');

//         // Basic Header Operations
//         header.style.backgroundColor = 'transparent';
//         header.style.borderBottom = 'transparent';
//         header.style.boxShadow = 'none';
//         header.style.paddingTop = '4px';
//         header.classList.add('abc');

//         // Basic innerHeader Operations
//         innerHeader.style.backgroundColor = '#fff';
//         innerHeader.style.paddingLeft = '20px';
//         innerHeader.style.paddingRight = '20px';
//         innerHeader.classList.add('rounded');

//         // Remove Default Height
//         headerGap.remove();
//     }
// }